var exports = {
  "xn": "EmbedYouTube.module__thumbnail___RjlqYV",
  "SK": "EmbedYouTube.module__thumbnailPlaceholder___RjlqYV",
  "Lw": "EmbedYouTube.module__overlay___RjlqYV",
  "lW": "EmbedYouTube.module__posterImage___RjlqYV",
  "_y": "EmbedYouTube.module__thumbnailClickTarget___RjlqYV",
  "gO": "EmbedYouTube.module__controlsContainer___RjlqYV",
  "GC": "EmbedYouTube.module__buttonGroup___RjlqYV",
  "kL": "EmbedYouTube.module__container___RjlqYV",
  "j": "EmbedYouTube.module__videoContainer___RjlqYV",
  "pU": "EmbedYouTube.module__iframe___RjlqYV",
};

module.exports = exports;
